import React from "react";
import { Link } from "react-router-dom";

import queryString from "query-string";

import validator from "validator";

import {
  Popup,
  EditableComponent,
  Loading,
  InputField,
} from "arteia-js/components";
import { API } from "arteia-js/services";
import { backgroundArtworks } from "../configs/backgroundArtworks.config";

const artwork =
  backgroundArtworks[Math.floor(Math.random() * backgroundArtworks.length)];
class Login extends EditableComponent {
  state = {
    email: "",
    password: "",

    loginSuccessful: false,
    loginErrored: false,
    loading: false,

    errorCode: null,
    errorMessage: "",
    visible: true,

    redirectUrl: null,
  };

  ERROR_MESSAGES = {
    404: "Email or password is not correct",
    401: "Email or password is not correct",
    403: "2FA is required for admin users",
    500: "Something went wrong",
  };

  returnPath() {
    return window.location.pathname + window.location.search;
  }

  euLoginStart = () => {
    API.get("/eu-login-authorize-url")
      .then((res) => window.location.assign(res.url))
      .catch((e) => {
        const { status } = e;
        this.setState({
          loading: false,
          loginErrored: true,
          errorCode: status,
          status,
          errorMessage: this.ERROR_MESSAGES[status] || this.ERROR_MESSAGES[500],
        });
      });
  };

  login = () => {
    const { email, password } = this.state;
    this.setState({ loading: true });

    const { history } = this.props;
    const { returnTo } = queryString.parse(history.location.search);

    API.post("/login", {
      email,
      password,
      isAdminPanel: returnTo.includes("admin-panel")
    })
      .then((res) => {
        const {
          settingPassword = false,
          twoFactorRequired = false,
          changePasswordId,
          isAdminPanel = false,
          twoFactorId,
        } = res;

        if (settingPassword === true) {
          this.setState({
            loading: false,
            visible: false,
            errorCode: null,
          });
          return history.push(`/password/update/${changePasswordId}`);
        }

        if (twoFactorRequired === true) {
          this.setState({
            loading: false,
            visible: false,
            errorCode: null,
          });
          return history.push("/twoFactor", { twoFactorId, returnTo, isAdminPanel: isAdminPanel || returnTo.includes("admin-panel") });
        } else {
          if (returnTo.includes("admin-panel") || isAdminPanel) {
            const err2FA = new Error();
            err2FA.status = 403;
            throw err2FA;           
          }
        }

        if (returnTo === "client") {
          API.getOrganisations(res.token)
            .then((profile) => {
              const { organisations } = profile.data;
              let redirect = "";

              if (!organisations.length) {
                const query = {
                  token: res.token,
                  returnTo: "accounts-client",
                };

                this.setState({
                  status: 200,
                  errorCode: null,
                });

                return window.location.assign(
                  `/redirect?${queryString.stringify(query)}`
                );
              }

              const nonDemoOrg = organisations.find((org) => !org.is_demo);
              if (!nonDemoOrg) {
                redirect = organisations[0].url;
              } else {
                redirect = nonDemoOrg.url;
              }

              const parts = redirect.split("/");
              const newReturnTo = `client/org/${
                parts[parts.length - 1]
              }/artworks`;

              const query = {
                token: res.token,
                returnTo: newReturnTo,
              };

              this.setState({
                status: 200,
                errorCode: null,
              });

              return window.location.assign(
                `/redirect?${queryString.stringify(query)}`
              );
            })
            .catch((err) => {
              const { status } = err;
              this.setState({
                loading: false,
                loginErrored: true,
                errorCode: status,
                status,
                errorMessage:
                  this.ERROR_MESSAGES[status] || this.ERROR_MESSAGES[500],
              });
            });
        } else {
          const query = {
            token: res.token,
            returnTo,
          };

          this.setState({
            status: 200,
            errorCode: null,
          });

          return window.location.assign(
            `/redirect?${queryString.stringify(query)}`
          );
        }
      })
      .catch((e) => {
        const { status } = e;
        this.setState({
          loading: false,
          loginErrored: true,
          errorCode: status,
          status,
          errorMessage: this.ERROR_MESSAGES[status] || this.ERROR_MESSAGES[500],
        });
      });
  };

  isDataCorrect = () => {
    const { email, password } = this.state;
    return validator.isEmail(email) && !validator.isEmpty(password);
  };

  handleKeyPress = (e) => {
    if (e.key === "Enter") {
      this.login();
    }
  };

  renderEuLoginButton() {
    const { history } = this.props;
    const { returnTo } = queryString.parse(history.location.search);

    // EU-Login button is only displayed for Collect login coming from login chooser
    if (
      returnTo &&
      (returnTo.includes("collect") || returnTo.includes("client"))
    ) {
      return (
        <div>
          <div className="or-text-wrapper">
            <p className="or-text-p">or</p>
          </div>
          <div className="button-container">
            <button
              id="eu-login-btn"
              className="eu-login-btn"
              onClick={this.euLoginStart}
            >
              <div className="eu-btn-content-wrapper">
                <img src="/EU-Logo.png" alt="EU Logo" width="45px" />
                EU-Login
                <img src="/ico-arrow-right.svg" />
              </div>
            </button>
          </div>
        </div>
      );
    }
  }

  componentDidMount() {
    const { history } = this.props;

    if (this.returnPath() === "/") {
      return history.push("/login");
    }
    const { state } = history.location;
    if (!!state && !!state.errorMessage) {
      this.setState({
        errorMessage: state.errorMessage,
      });
    }
  }

  render() {
    const { email, password, loading, errorMessage, status, visible } =
      this.state;

    return (
      <div
        className="login-form-wrapper"
        style={{ backgroundImage: `url(${artwork.asset})` }}
      >
        <div className="artwork-details">
          <span className="artist-name">{artwork.artistName}</span>
          <br />
          <span className="artwork-title">
            {artwork.title}, {artwork.year}
          </span>
        </div>
        <span className="all-rights-reserved">
          &copy; {new Date().getFullYear()} Arteïa - All rights reserved
        </span>
        <Popup
          size="form"
          noTitle
          noCloseHandler
          className="form login-form"
          loading={loading}
          visible={visible}
          loadingComponent={<Loading />}
        >
          <div className="popup-content">
            <h1>Login to your account</h1>

            <span className="input-label">Email</span>
            <InputField
              type={"email"}
              value={email}
              onChange={this.onFieldChange("email")}
            />

            <span className="input-label">Password</span>
            <InputField
              type={"password"}
              value={password}
              onChange={this.onFieldChange("password")}
              handleKeyPress={this.handleKeyPress}
            />

            <div className="form-msg">
              <span className="error-msg">
                {status !== 200 && errorMessage}
              </span>
            </div>
            <div className="button-container">
              <button
                id={
                  this.returnPath() === "/?returnTo=connect"
                    ? "connect-btn"
                    : ""
                }
                className="art-btn"
                disabled={!this.isDataCorrect() || status === 200}
                onClick={this.login}
              >
                LOG IN
                <img src="/ico-arrow-right.svg" />
              </button>
            </div>
            <Link className="secondary-link" to="/forgot-password">
              Forgot password?
            </Link>
            <Link
              className="secondary-link"
              to={
                this.returnPath() === "/?returnTo=connect"
                  ? "/sign-up-to?returnTo=connect"
                  : "/sign-up-to?returnTo=collect"
              }
            >
              Don't have an account?
            </Link>
            {this.renderEuLoginButton()}
          </div>
        </Popup>
      </div>
    );
  }
}

Login.propTypes = {};
Login.defaultProps = {};

export default Login;



// WEBPACK FOOTER //
// ./src/scenes/Login/index.js